import type { PolicyResultItem } from '@/lib/apiTypes'

/** Per-policy pass/fail for this module version (surfaced in the version detail). */
export function PolicyResultsCard({ results, enabled }: { results: PolicyResultItem[]; enabled: boolean }) {
  if (!enabled || results.length === 0) return null
  const failing = results.filter((r) => !r.passed).length
  return (
    <div style={{ marginTop: 16, background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 8, padding: '12px 14px', display: 'grid', gap: 8 }}>
      <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between' }}>
        <span style={{ fontFamily: 'var(--mono)', fontSize: '0.65rem', color: 'var(--text3)', letterSpacing: '0.08em' }}>// policy results</span>
        <span className={failing > 0 ? 'badge badge-red' : 'badge badge-green'} style={{ fontSize: '0.62rem' }}>
          {failing > 0 ? `${failing} failing` : 'all passing'}
        </span>
      </div>
      {results.map((r) => (
        <div key={r.policy_id} style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
          <span style={{ color: r.passed ? 'var(--green)' : 'var(--red)', fontSize: '0.8rem', lineHeight: 1.4 }}>{r.passed ? '✓' : '✗'}</span>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: '0.8rem', color: 'var(--text)' }}>{r.policy_name}</div>
            {!r.passed && r.failure_msg && (
              <div style={{ fontSize: '0.72rem', color: 'var(--text2)', marginTop: 2 }}>{r.failure_msg}</div>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}
